const COLOR_POSITION = {
    GREEN: 5,
    LIGHT_GREEN: 27,
    YELLOW: 50,
    LIGHT_RED: 80,
    RED: 95,
};

// Sub-componente para los items de resultados individuales
const ResultItem = ({ label, value, unit, color, onClickInfo }) => {

    const handleIconClick = (e) => {
        e.stopPropagation(); // Evita que el clic afecte a otros elementos padres
        onClickInfo();
    };

    return (
        <div className={`item-result${color ? '' : ' item-result--score'}`} >
            <div className="info-results">
                <span className="name-exam">{label}</span>
                <span className="data-exam">
                    {value ?? '-'} <small>{unit ?? '-'}</small>
                </span>
            </div>
            <div className="grafic-card-vitals">
                {color ? (
                    <div className="heat-bar">
                        <span
                            className="heat-indicator"
                            style={{ left: `${COLOR_POSITION[color]}%` }}
                        ></span>
                    </div>
                ) : (
                    <div className="heat-bar empty">
                        <span
                            className="heat-indicator empty"
                            style={{ left: `${COLOR_POSITION[color]}%` }}
                        ></span>
                    </div>
                )}
                <i
                    className="icon icon_enlinea_info"
                    onClick={handleIconClick}
                    style={{ cursor: 'pointer' }}
                ></i>
            </div>
        </div>
    );
};

export { ResultItem };